import { render, staticRenderFns } from "./UrunVariantItem.vue?vue&type=template&id=27c933ae&scoped=true"
import script from "./UrunVariantItem.vue?vue&type=script&lang=js"
export * from "./UrunVariantItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c933ae",
  null
  
)

export default component.exports